function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
import cx from "classnames";
import { twMerge } from "../../../utils/twMerge";
export function Body(props) {
    var tmp = props.as, As = tmp === void 0 ? "div" : tmp, _variant = props.variant, variant = _variant === void 0 ? "default" : _variant, className = props.className, children = props.children, rest = _objectWithoutProperties(props, [
        "as",
        "variant",
        "className",
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(As, _extends({
        className: twMerge(cx("font-normal leading-relaxed", variant === "default" && "text-body.small md:text-body.base", variant === "big" && "text-body.base md:text-body.large", variant === "small" && "text-body.xsmall", className))
    }, rest), children);
}

//# sourceMappingURL=Body.js.map